export default {
  profile: {
    title: "Mi perfil",
    personalInfo: "Información personal",
    firstName: "Nombre",
    lastName: "Apellidos",
    firstNamePlaceholder: "Tu nombre",
    lastNamePlaceholder: "Tus apellidos",
    email: "Email",
    emailHelp: "Para cambiar tu email contacta con el administrador.",
    changePassword: "Cambiar contraseña",
    passwordHelp: "Deja estos campos en blanco si no quieres cambiar tu contraseña.",
    currentPassword: "Contraseña actual",
    newPassword: "Nueva contraseña",
    newPasswordPlaceholder: "Mínimo 8 caracteres",
    confirmPassword: "Confirmar nueva contraseña",
    passwordsNoMatch: "Las contraseñas no coinciden.",
    language: "Idioma",
    languageDesc: "Elige el idioma de la interfaz de HelixScan.",
    languageNote: "Los informes PDF mantienen su propio idioma, configurable al generarlos.",
    spanish: "Español",
    english: "Inglés",
    saving: "Guardando…",
    saveChanges: "Guardar cambios",
    needCurrentPwd: "Debes introducir tu contraseña actual.",
    pwdTooShort: "La nueva contraseña debe tener al menos 8 caracteres.",
    pwdMismatch: "La nueva contraseña y su confirmación no coinciden.",
    saved: "Cambios guardados correctamente.",
    saveError: "Error al guardar los cambios.",
  },
};
